<template>
  <div>
    <LibrarySelect v-on:url-submit="urlSubmit" />
    <LaunchViewer
      v-if="satellite"
      v-bind:satellite="satellite"
      v-on:removeLibrary="removeLibrary"
    />
    <!--<Todo v-if="!satellite" />-->
  </div>
</template>

<script>
import LibrarySelect from "../components/LibrarySelect";
import LaunchViewer from "../components/LaunchViewer";
//import Todo from "../components/Todo";
import addFrame from "../scripts/addframe";
import {
  loadExternalScripts,
  deleteExtenalScripts,
} from "../scripts/loadExternalScripts";

export default {
  name: "Launch",
  components: {
    LibrarySelect,
    LaunchViewer,
    //Todo
  },
  data() {
    return {
      launchUrl: "",
      frame: undefined,
      satellite: false,
    };
  },
  methods: {
    loadcallback(sat, assetDomain) {
      // ==> window public callback
      window._satellite = sat;
      loadExternalScripts(sat, assetDomain); // load with support for external asset domains
      this.satellite = sat;
    },
    urlSubmit(v) {
      if (v === this.launchUrl) {
        return;
      }
      window.loadcallback = this.loadcallback;
      this.launchUrl = v;
      this.satellite = undefined; // IMPORTANT ==> resets LaunchViewser
      this.frame = addFrame(v, "loadcallback"); // callback needs to be public on window!
    },
    removeLibrary() {
      this.frame.parentNode.removeChild(this.frame);
      deleteExtenalScripts();
      this.frame = undefined;
      this.launchUrl = "";
      window._satellite = undefined;
      this.satellite = false;
    },
  },
};
</script>